<div class="available-month-dates-operation">
    <span class="time-details">
        <select value="{{ defaultValues.date }}" (change)="onValueChange($event, 'date')">
            <option value="" disabled selected>Select Date</option>
            <option value="all">All Dates</option>
            <ng-container *ngFor="let day of [].constructor(31); let i = index">
                <option [value]="i + 1">{{ i + 1 }}</option>
            </ng-container>
        </select>
    </span>

    <span class="time-details">
        <input
            type="time"
            value="{{ defaultValues.openingTime }}"
            (change)="onValueChange($event, 'openingTime')"
        />
    </span>

    <span class="time-details">
        <input
            type="time"
            value="{{ defaultValues.closingTime }}"
            (change)="onValueChange($event, 'closingTime')"
        />
    </span>
</div>
